export default {
  heroSlogan: '专注跨境全链路服务，整合法律、金融与商务，护航企业出海',
  consultNow: '立即咨询',
  learnMore: '了解更多',
  advantageTitle1: '20年+经验',
  advantageDesc1: '深耕跨境服务领域20余年，服务超过100+家企业',
  advantageTitle2: '全球网络',
  advantageDesc2: '覆盖50+国家和地区的服务网络',
  advantageTitle3: '专业可靠',
  advantageDesc3: '专业法律、财税、商务团队，确保服务质量',
  advantageTitle4: '一站式服务',
  advantageDesc4: '从公司注册到运营管理的全流程服务',
}
